module.exports = __webpack_public_path__ + "static/media/model_1.8f80bc01.jpg";